import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Components
import Spinner from "../layout/Spinner";
import PantryItemObject from "./PantryItemObject";

import { Checkbox, TextField, Button, IconButton, Typography } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

//Icons
import { ReactComponent as FiltersIcon } from "../../assets/icons/svg/sliders-light.svg";
import { ReactComponent as AscendingIcon } from "../../assets/icons/svg/chevron-up.svg";
import { ReactComponent as DescendingIcon } from "../../assets/icons/svg/chevron-down.svg";

function ItemsList({ pantry: { locationItems }, location, items, loading, error }) {
  const [searchTerm, setSearchTerm] = useState("");

  const [nameSort, setNameSort] = useState("asc");
  const [expirySort, setExpirySort] = useState("asc");

  // Add sorting functions and search filter logic here

  return (
    <div className="w-full mt-4 h-full">
      <TextField
        id="search"
        label="Search..."
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        size="small"
        className="bg-backround rounded-lg"
      />
      <div className="flex flex-row justify-between mt-2">
        <Button onClick={() => setNameSort(nameSort === "asc" ? "desc" : "asc")}>
          Name
          {nameSort === "asc" ? (
            <AscendingIcon className="h-2 w-2 ml-1" />
          ) : (
            <DescendingIcon className="h-2 w-2 ml-1" />
          )}
        </Button>
        <Button onClick={() => setExpirySort(expirySort === "asc" ? "desc" : "asc")}>
          Use Within
          {expirySort === "asc" ? (
            <AscendingIcon className="h-2 w-2 ml-1" />
          ) : (
            <DescendingIcon className="h-2 w-2 ml-1" />
          )}
        </Button>
      </div>
      <div className="custom-scrollbar h-[20rem] flex-1 overflow-y-auto w-full border border-separator rounded-lg bg-background">
        {loading ? (
          <Spinner />
        ) : error ? (
          <Typography>Error</Typography>
        ) : items.length > 0 ? (
          items.map((item, index) => <PantryItemObject key={item._id} item={item} index={index} location={location} />)
        ) : (
          <div className="flex flex-col items-center justify-center text-center px-4 py-8">
            <Typography variant="subtitle1">
              No items in the {location.name}. Add items to get recipes, track your items
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}

ItemsList.propTypes = {
  pantry: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
});

export default connect(mapStateToProps)(ItemsList);
